import { PayPeriodViewModel } from "interfaces/Mueller.Business.Models";
import React, { useState } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Icon from "@mui/material/Icon";

interface PayPeriodDropDownProps {
  payPeriods: PayPeriodViewModel[],
  selectedIndex?: number,
  payPeriodChangeCallback: (newIndex: number) => void,
}

const PayPeriodDropdown = (props: PayPeriodDropDownProps) => {

  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (index: number) => {
    props.payPeriodChangeCallback(index);
    setSelectedIndex(index);
    handleClose();
  };

  return (
    <div className="my-time-log-filter">
      <Button
        onClick={handleClick}
        endIcon={<Icon>arrow_drop_down</Icon>}
      >
        {props.payPeriods?.[props.selectedIndex ?? selectedIndex]?.fromToDisplay ?? ""}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {props.payPeriods?.map((payPeriod, index) => (
          <MenuItem
            key={`pay-period-id-${payPeriod.id}`}
            onClick={() => handleMenuItemClick(index)}
          >
            {payPeriod.fromToDisplay}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default PayPeriodDropdown;
